import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'xs-lib-spin',
  templateUrl: './spin.component.html',
  styleUrls: ['./spin.component.css']
})
export class SpinComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
